import { ReactNode } from "react";

export const SvgLinkedin = (): ReactNode => {
	return (
		<svg width="24" height="24" viewBox="0 0 382 382" fill="none">
			<path
				d="M347.445,0H34.555C15.471,0,0,15.471,0,34.555v312.889C0,366.529,15.471,382,34.555,382h312.889
				C366.529,382,382,366.529,382,347.444V34.555C382,15.471,366.529,0,347.445,0z M118.207,329.844c0,5.554-4.502,10.056-10.056,10.056
				H65.345c-5.554,0-10.056-4.502-10.056-10.056V150.403c0-5.554,4.502-10.056,10.056-10.056h42.806
				c5.554,0,10.056,4.502,10.056,10.056V329.844z M86.748,123.432c-22.459,0-40.666-18.207-40.666-40.666S64.289,42.1,86.748,42.1
				s40.666,18.207,40.666,40.666S109.208,123.432,86.748,123.432z M341.91,330.654c0,5.106-4.14,9.246-9.246,9.246H286.73
				c-5.106,0-9.246-4.14-9.246-9.246v-84.168c0-12.556,3.683-55.021-32.813-55.021c-28.309,0-34.051,29.066-35.204,42.11v97.079
				c0,5.106-4.139,9.246-9.246,9.246h-44.426c-5.106,0-9.246-4.14-9.246-9.246V149.593c0-5.106,4.14-9.246,9.246-9.246h44.426
				c5.106,0,9.246,4.14,9.246,9.246v15.655c10.497-15.753,26.097-27.912,59.312-27.912c73.552,0,73.131,68.716,73.131,106.472
				L341.91,330.654L341.91,330.654z"
				fill="currentColor"
			/>
		</svg>
	);
};

export const SvgFacebook = (): ReactNode => {
	return (
		<svg width="36" height="36" viewBox="0 0 36 36" fill="none">
			<path
				d="M18 6C11.373 6 6 11.373 6 18C6 23.989 10.388 28.954 16.125 29.854V21.469H13.078V18H16.125V15.356C16.125 12.349 17.917 10.688 20.658 10.688C21.97 10.688 23.344 10.922 23.344 10.922V13.875H21.83C20.34 13.875 19.875 14.8 19.875 15.75V18H23.203L22.67 21.469H19.875V29.854C25.612 28.954 30 23.989 30 18C30 11.373 24.627 6 18 6Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export const SvgInstagram = (): ReactNode => {
	return (
		<svg width="36" height="36" viewBox="0 0 36 36" fill="none">
			<path
				d="M18 10.5C13.858 10.5 10.5 13.858 10.5 18C10.5 22.142 13.858 25.5 18 25.5C22.142 25.5 25.5 22.142 25.5 18C25.5 13.858 22.142 10.5 18 10.5ZM18 23C15.243 23 13 20.757 13 18C13 15.243 15.243 13 18 13C20.757 13 23 15.243 23 18C23 20.757 20.757 23 18 23ZM23.5 6H12.5C8.91 6 6 8.91 6 12.5V23.5C6 27.09 8.91 30 12.5 30H23.5C27.09 30 30 27.09 30 23.5V12.5C30 8.91 27.09 6 23.5 6ZM27.5 23.5C27.5 25.71 25.71 27.5 23.5 27.5H12.5C10.29 27.5 8.5 25.71 8.5 23.5V12.5C8.5 10.29 10.29 8.5 12.5 8.5H23.5C25.71 8.5 27.5 10.29 27.5 12.5V23.5Z"
				fill="currentColor"
			/>
			<circle cx="24.5" cy="11.5" r="1.5" fill="currentColor" />
		</svg>
	);
};

export const SvgX = (): ReactNode => {
	return (
		<svg width="44" height="44" viewBox="0 0 36 36" fill="none">
			<path
				d="M21.5 16.2L27.5 9H25.9L20.7 15.2L16.6 9H10L16.3 18.8L10 26.5H11.6L17.1 19.9L21.4 26.5H28L21.5 16.2ZM17.9 18.9L17.2 17.9L12.2 10.2H15.7L19.6 16.3L20.3 17.3L25.9 25.4H22.4L17.9 18.9Z"
				fill="currentColor"
			/>
		</svg>
	);
};
